<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'imgcropper',
})
</script>
<template>
  <a-modal
      title="修改头像"
      v-model:open="visible"
      :maskClosable="false"
      :confirmLoading="confirmLoading"
      :width="800"
      @ok="finish"
      @cancel="close"
    >
      <a-row>
        <a-col
          :xs="24"
          :md="12"
          :style="{height: '350px'}"
        >
          <vue-cropper
            ref="cropper"
            :img="options.img"
            :output-size="options.size"
            :info="true"
            :full="options.full"
            :fixed="options.fixed"
            :fixed-number="options.fixedNumber"
            :can-move="options.canMove"
            :can-move-box="options.canMoveBox"
            :autoCrop="options.autoCrop"
            :autoCropWidth="options.autoCropWidth"
            :autoCropHeight="options.autoCropHeight"
            :fixedBox="options.fixedBox"
            :center-box="options.centerBox"
            :high="options.high"
            mode="cover"
            :max-img-size="options.max"
            @realTime="realTime" />
        </a-col>
        <a-col
          :xs="24"
          :md="12"
          :style="{height: '350px'}"
        >
          <div class="avatar-upload-preview">
            <img
              :src="previews.url"
              :style="previews.img"
            />
          </div>
        </a-col>
      </a-row>
      <div>
         <a-upload
            name="file"
            :beforeUpload="beforeUpload"
            :showUploadList="false"
          >
            <a-button type="primary">选择图片</a-button>
          </a-upload>
        <a-button-group>
            <a-button  @click="changeScale(1)" > 放大 </a-button>
            <a-button  @click="changeScale(-1)" > 缩小 </a-button>
            <a-button @click="rotateLeft">左转</a-button>
            <a-button  @click="rotateRight">右转</a-button>
        </a-button-group>
        <a-button  type="primary"  @click="finish('blob')" >保存</a-button>
      </div>
    </a-modal>
</template>
<script setup lang="ts" name="imgcropper">
import {ref,reactive,defineProps,watch,onMounted} from 'vue'
import { baseURL } from '@/utils/util'
import axios, { AxiosResponse } from 'axios'
import { CloudUploadOutlined,PlusOutlined } from '@ant-design/icons-vue'
import {VueCropper} from 'vue-cropper'
import 'vue-cropper/dist/index.css'
import {message} from 'ant-design-vue'
const baseService = axios.create({
  timeout: 60000,
  responseType: 'json',
  headers: {'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'}
})
const props=defineProps({
  img:{type:String,default:''},
  open:{type:Boolean,default:false}
})
watch(()=>props.open,(n)=>{
  visible.value=n
})
onMounted(()=>{
  options.img=props.img
})

const emit=defineEmits(['update:open','change'])
const visible=ref<Boolean>(false)
const id=ref<number|null>(null)
const confirmLoading=ref<Boolean>(false)
const uploading=ref<Boolean>(false)

const fileList=ref<Array>([])
const previews=ref<any>({url:'',img:''})
let options=reactive<Record<any>>({
        img:'',
        full: true,  // 是否输出原图比例
        info: true,
        size: 1,
        outputType: 'png',// 输出图片格式
        canScale: false,//是否可缩放
        canMove: true, // 图片是否可移动
        canMoveBox: false, // 截图框是否可移动
        autoCrop: true,// 是否开启截图
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 256,// 输出图片宽高
        autoCropHeight: 256,
        fixedBox: true, // 截图框是否固定
        centerBox: true,  // 是否开启截图框固定宽高
        max: 99999,  // 输出图片大小限制
        fixed: true,// 是否开启截图框固定宽高
        high: true,  // 是否开启图片移动
        fixedNumber: [1, 1],
      })
const cropper=ref()
const close=()=>{
  visible.value=false
  emit('update:open',visible.value)
}
const changeScale=(num:number):void=> {
      num = num || 1
      cropper.value.changeScale(num)
    }
const rotateLeft=():void=> {
      cropper.value.rotateLeft()
    }
const rotateRight=():void=> {
      cropper.value.rotateRight()
    }
const beforeUpload=(file:File):void=> {
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        options.img = reader.result
      }
      return false
    }

    // 上传图片（点击上传按钮）
const finish=():void=> {
      const formData = new FormData()
        cropper.value.getCropBlob((data) => {
          const img = window.URL.createObjectURL(data)
          const file = new window.File([data], 'avatar.jpg', { type: data.type })
          formData.append('file', file)
          baseService.post(baseURL + '/Upload/UploadWangEditor', formData).then((response) => {
            if(response.data&&response.data.state==1){
              let url=response.data[0].href
              options.img = url
              emit('change',url)
               message.success('上传成功')
              visible.value = false
            }else{
              message.error('上传失败,'+response.data.mesage)
            }
          })
        })

    }

const realTime=(data:any)=> {
      previews.value = data
    }
</script>


<style lang="less" scoped>
.avatar-upload-preview {
  position: absolute;
  top: 50%;
  transform: translate(50%, -50%);
  width: 180px;
  height: 180px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}
.ant-upload-preview {
  position: relative;
  margin: 0 auto 10px auto;
  width: 100%;
  max-width: 130px;
  border-radius: 50%;
  box-shadow: 0 0 4px #ccc;

  .upload-icon {
    position: absolute;
    top: 0;
    right: 10px;
    font-size: 1.4rem;
    padding: 0.5rem;
    background: rgba(222, 221, 221, 0.7);
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.2);
  }
  .mask {
    opacity: 0;
    position: absolute;
    background: rgba(0, 0, 0, 0.4);
    cursor: pointer;
    transition: opacity 0.4s;

    &:hover {
      opacity: 1;
    }

    i {
      font-size: 2rem;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -1rem;
      margin-top: -1rem;
      color: #d6d6d6;
    }
  }

  img,
  .mask {
    width: 100%;
    max-width: 180px;
    height: 100%;
    border-radius: 50%;
    overflow: hidden;
  }
}
</style>
